// extracted by mini-css-extract-plugin
export default {"modalOverlay":"pz-z","modalContent":"qz-z","header":"rz-z","close":"sz-z"};